/* ============================================================
   FAST AND DRINK — theme.js (vanilla)
   ============================================================ */
(function () {
  "use strict";

  var money = window.FAD && window.FAD.moneyFormat ? window.FAD.moneyFormat : "{{amount}} €";
  function formatMoney(cents) {
    var v = cents / 100;
    var dec = v.toFixed(2);
    var decComma = dec.replace(".", ",");
    var nodec = Math.round(v).toString();
    return money
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, decComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, nodec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, nodec)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, dec.replace(".", "'"))
      .replace(/\{\{\s*amount\s*\}\}/, dec);
  }

  /* ---------- Skip link ---------- */
  var skipLink = document.querySelector(".skip-link");
  if (skipLink) {
    skipLink.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden";
    skipLink.addEventListener("focus", function () {
      skipLink.style.cssText = "position:fixed;top:8px;left:8px;z-index:99999;padding:10px 18px;background:#B06BFF;color:#0A0814;font-weight:700;border-radius:10px;text-decoration:none";
    });
    skipLink.addEventListener("blur", function () {
      skipLink.style.cssText = "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden";
    });
  }

  /* ---------- Header scroll ---------- */
  var header = document.querySelector(".site-header");
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 40) header.classList.add("is-scrolled");
    else header.classList.remove("is-scrolled");
    var top = document.querySelector(".float-top");
    if (top) {
      if (window.scrollY > 500) top.classList.add("is-visible");
      else top.classList.remove("is-visible");
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- Menu mobile ---------- */
  var burger = document.querySelector("[data-burger]");
  var mobileNav = document.querySelector(".mobile-nav");
  function closeMobile() { if (mobileNav) mobileNav.classList.remove("is-open"); }
  if (burger && mobileNav) {
    burger.addEventListener("click", function () { mobileNav.classList.toggle("is-open"); });
  }
  document.querySelectorAll("[data-mobile-close]").forEach(function (el) {
    el.addEventListener("click", closeMobile);
  });

  /* ---------- Vérification d'âge ---------- */
  var ageGate = document.querySelector(".age-gate");
  if (ageGate) {
    var ok = false;
    try { ok = localStorage.getItem("fad_age_ok") === "1"; } catch (e) {}
    if (ok) {
      ageGate.setAttribute("hidden", "");
    } else {
      ageGate.removeAttribute("hidden");
      document.body.style.overflow = "hidden";
    }
    var confirmBtn = ageGate.querySelector("[data-age-confirm]");
    var denyBtn = ageGate.querySelector("[data-age-deny]");
    if (confirmBtn) confirmBtn.addEventListener("click", function () {
      try { localStorage.setItem("fad_age_ok", "1"); } catch (e) {}
      ageGate.setAttribute("hidden", "");
      document.body.style.overflow = "";
    });
    if (denyBtn) denyBtn.addEventListener("click", function () {
      window.location.href = "https://www.google.com";
    });
  }

  /* ---------- FAQ accordéon ---------- */
  document.querySelectorAll(".faq__q").forEach(function (q) {
    q.addEventListener("click", function () {
      var item = q.closest(".faq__item");
      var answer = item.querySelector(".faq__a");
      var open = item.classList.toggle("is-open");
      answer.style.maxHeight = open ? answer.scrollHeight + "px" : null;
    });
  });

  /* ---------- Reveal au scroll ---------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- Onglets catalogue ---------- */
  document.querySelectorAll("[data-tab]").forEach(function (tab) {
    tab.addEventListener("click", function () {
      var url = tab.getAttribute("data-tab-url");
      if (url) window.location.href = url;
    });
  });

  /* ============================================================
     PANIER AJAX
     ============================================================ */
  var drawer = document.querySelector(".cart-drawer");
  var overlay = document.querySelector(".cart-overlay");

  function openDrawer() { if (drawer) { drawer.classList.add("is-open"); if (overlay) overlay.classList.add("is-open"); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("is-open"); if (overlay) overlay.classList.remove("is-open"); } }

  document.querySelectorAll("[data-cart-toggle]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); renderCart(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });
  if (overlay) overlay.addEventListener("click", closeDrawer);

  function updateCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  function renderCart() {
    var container = document.querySelector("[data-cart-items]");
    var totalEl = document.querySelector("[data-cart-total]");
    if (!container) return;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        if (!cart.items.length) {
          container.innerHTML = '<div class="cart-empty">Votre panier est vide.</div>';
          return;
        }
        var html = "";
        cart.items.forEach(function (item) {
          var img = item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : "";
          html +=
            '<div class="cart-line" data-key="' + item.key + '">' +
              '<div class="cart-line__img">' + img + "</div>" +
              '<div class="cart-line__info">' +
                '<p class="cart-line__title">' + item.product_title + "</p>" +
                '<div class="qty">' +
                  '<button data-qty-minus aria-label="Moins">−</button>' +
                  '<input type="text" value="' + item.quantity + '" data-qty-input readonly>' +
                  '<button data-qty-plus aria-label="Plus">+</button>' +
                "</div>" +
              "</div>" +
              '<div style="text-align:right">' +
                '<div class="cart-line__price">' + formatMoney(item.final_line_price) + "</div>" +
                '<button class="cart-line__remove" data-remove>Retirer</button>' +
              "</div>" +
            "</div>";
        });
        container.innerHTML = html;
        bindLineEvents();
      })
      .catch(function () {});
  }

  function changeItem(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function bindLineEvents() {
    document.querySelectorAll(".cart-line").forEach(function (line) {
      var key = line.getAttribute("data-key");
      var input = line.querySelector("[data-qty-input]");
      var minus = line.querySelector("[data-qty-minus]");
      var plus = line.querySelector("[data-qty-plus]");
      var remove = line.querySelector("[data-remove]");
      if (minus) minus.addEventListener("click", function () {
        var q = Math.max(0, parseInt(input.value, 10) - 1);
        changeItem(key, q).then(function (c) { updateCount(c.item_count); renderCart(); });
      });
      if (plus) plus.addEventListener("click", function () {
        var q = parseInt(input.value, 10) + 1;
        changeItem(key, q).then(function (c) { updateCount(c.item_count); renderCart(); });
      });
      if (remove) remove.addEventListener("click", function () {
        changeItem(key, 0).then(function (c) { updateCount(c.item_count); renderCart(); });
      });
    });
  }

  /* ---------- Ajout au panier (formulaires) ---------- */
  document.querySelectorAll("form[data-add-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = "Ajout…"; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: form.querySelector("[name=id]").value,
          quantity: parseInt((form.querySelector("[name=quantity]") || {}).value || 1, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCount(cart.item_count);
          openDrawer();
          renderCart();
        })
        .catch(function () {})
        .finally(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || "Ajouter au panier"; }
        });
    });
  });

  /* ---------- Quantité sur fiche produit ---------- */
  document.querySelectorAll("[data-product-qty]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    wrap.querySelector("[data-qty-minus]").addEventListener("click", function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
    wrap.querySelector("[data-qty-plus]").addEventListener("click", function () {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ---------- Galerie produit ---------- */
  var mainImg = document.querySelector("[data-product-main] img");
  document.querySelectorAll("[data-product-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute("data-full");
      document.querySelectorAll("[data-product-thumb]").forEach(function (t) { t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
    });
  });
  var mainWrap = document.querySelector("[data-product-main]");
  if (mainWrap) mainWrap.addEventListener("click", function () { mainWrap.classList.toggle("zoomed"); });

  /* Init compteur panier au chargement */
  fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); }).catch(function () {});
})();
